(() => {
  const reveal = () => {
    const items = document.querySelectorAll('.ss-reveal:not(.ss-is-visible)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('ss-is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ss-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  document.addEventListener('DOMContentLoaded', reveal, { once: true });
  document.addEventListener('shopify:section:load', reveal);
})();
